import React, { Component } from 'react';
import pretty from 'pretty';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import top from './top.png';
import bottom from './bottom.png';
import squareBoxes from './square-boxes.png';
import './contentarea.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IntercomAPI } from 'react-intercom';

import Frame, { FrameContextConsumer } from 'react-frame-component';

class ContentArea extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copied: false,
      device: 'desktop',
      contentAreaHeight: 0,
    };

    this.copyToClipboardRef = React.createRef();
    this.markupRef = React.createRef();
    this.contentArea = React.createRef();
    this.contentAreaHeightCheck = null;
  }

  copyToClipboard = () => {
    this.markupRef.current.select();
    // this.copyToClipboardRef.current.select();
    // document.execCommand("copy");
  };

  getMarkup() {
    return pretty(this.props.htmlOutput);
  }

  showNotification = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 2000);
  };

  setDevice = e => {
    this.setState({
      device: e.target.value,
    });
  };

  renderHead = () => {
    const styleTag = 'html, body { margin: 0; padding: 0 }';
    return (
      <React.Fragment>
        <style dangerouslySetInnerHTML={{ __html: styleTag }} />
      </React.Fragment>
    );
  };

  recalculateHeight() {
    if (
      this.contentArea.document &&
      this.state.contentAreaHeight !== this.contentArea.document.documentElement.offsetHeight
    ) {
      this.setState(() => ({
        contentAreaHeight: this.contentArea.document.documentElement.offsetHeight,
      }));
    }
  }

  componentWillMount() {
    IntercomAPI('trackEvent', 'Email Studio - Application View Impression');
  }

  render() {
    const emailContainerStyles = {
      maxWidth: '640px',
      margin: '20px auto',
      WebkitBoxShadow: '0 3px 10px 0 rgba(0,0,0,0.3)',
      boxShadow: '0 3px 10px 0 rgba(0,0,0,0.3)',
    };

    return (
      <div className="App-contentarea">
        <section className="preview-pane">
          <div className="section-title">
            <span>Preview</span>
            <div className="preview-device-selector-wrapper">
              <button
                className={`device-selector-btn ${this.state.device === 'mobile' ? 'active' : ''}`}
                value="mobile"
                onClick={this.setDevice.bind(this)}
              >
                <FontAwesomeIcon icon="mobile-alt" />
              </button>
              <button
                className={`device-selector-btn ${this.state.device === 'tablet' ? 'active' : ''}`}
                value="tablet"
                onClick={this.setDevice}
              >
                <FontAwesomeIcon icon="tablet-alt" />
              </button>
              <button
                className={`device-selector-btn ${this.state.device === 'desktop' ? 'active' : ''}`}
                value="desktop"
                onClick={this.setDevice}
              >
                <FontAwesomeIcon icon="desktop" />
              </button>
            </div>
          </div>
          <div className={`preview-wrapper`}>
            <Frame
              className={`preview-container ${this.state.device}`}
              style={{ height: this.state.contentAreaHeight }}
              head={this.renderHead()}
              onLoad={this.recalculateHeight.bind(this)}
              contentDidUpdate={this.recalculateHeight.bind(this)}
            >
              <FrameContextConsumer>
                {({ document, window }) => {
                  this.contentArea = window;
                  if (this.contentAreaHeightCheck) {
                    clearInterval(this.contentAreaHeightCheck);
                  }
                  this.contentAreaHeightCheck = setInterval(() => {
                    this.recalculateHeight();
                  }, 250);

                  return (
                    <div style={emailContainerStyles}>
                      <img src={top} alt="Top Placeholder" style={{ width: '100%' }} />
                      {this.props.htmlOutput ? (
                        <div dangerouslySetInnerHTML={{ __html: this.getMarkup() }} />
                      ) : (
                        <img
                          style={{ margin: '10px 0', width: '100%' }}
                          src={squareBoxes}
                          alt="User-generated content"
                        />
                      )}

                      <img src={bottom} alt="Bottom Placeholder" style={{ width: '100%' }} />
                    </div>
                  );
                }}
              </FrameContextConsumer>
            </Frame>
          </div>
        </section>
        <section className="code-output">
          <span className="section-title">HTML Snippet</span>
          <pre ref={this.markupRef}>{this.getMarkup()}</pre>
          <CopyToClipboard
            text={this.props.htmlOutput}
            disabled={!this.props.htmlOutput}
            onCopy={this.showNotification}
          >
            <button>Copy to clipboard</button>
          </CopyToClipboard>
          {this.state.copied && (
            <span className="copy-notification" style={{ marginLeft: '10px' }}>
              Copied to clipboard!
            </span>
          )}
        </section>
      </div>
    );
  }
}

export default ContentArea;



// WEBPACK FOOTER //
// ./src/components/ContentArea/contentarea.js